// src/components/ui/Badge.jsx

import { cn } from '@/lib/utils';

export function Badge({ children, variant = 'default', className }) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium',
        {
          'bg-gray-100 text-gray-800': variant === 'default',
          'bg-green-100 text-green-800': variant === 'success',
          'bg-red-100 text-red-800': variant === 'error',
          'bg-yellow-100 text-yellow-800': variant === 'warning',
          'bg-blue-100 text-blue-800': variant === 'info',
          'border border-gray-200 bg-white text-gray-800': variant === 'outline',
        },
        className
      )}
    >
      {children}
    </span>
  );
}